import * as React from 'react';
import { useRef } from 'react';

import { UitkLink } from 'uitk-react-link';

import { AmenitiesList } from '.';
import { ToggleLink } from '..';
import { FlightsJourneyFare, FareTypeRuleCategory } from 'types/shared';
import { focusElement } from 'utility/focus-element';

interface FareDetailsToggleProps {
  fare: FlightsJourneyFare;
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  isExpanded: boolean;
}

export const FareDetailsToggle = ({ fare, isExpanded, setExpanded }: FareDetailsToggleProps) => {
  const headingRef = useRef(null);
  const toggleFareDetails = () => {
    setExpanded(!isExpanded);

    setTimeout(() => {
      focusElement(headingRef);
    }, 50);
  };

  return (
    <>
      <div className="all-t-margin-two">
        {isExpanded ? (
          <div className="all-t-margin-three" tabIndex={-1} ref={headingRef} data-test-id="amenities-expanded-list">
            {fare.expandedRules.map((category: FareTypeRuleCategory, index: number) => (
              <div key={index} className={index ? 'all-t-margin-six' : 'all-t-margin-one all-t-padding-three'}>
                <AmenitiesList amenities={category.rules.amenities} heading={category.label} />
              </div>
            ))}
          </div>
        ) : (
          <AmenitiesList amenities={fare.collapsedRules.amenities} />
        )}
      </div>
      {fare.showMoreAmenitiesToggle && (
        <UitkLink inline={true} className="all-b-margin-six all-b-padding-one">
          <ToggleLink
            flightsToggle={fare.showMoreAmenitiesToggle}
            handleActionClick={toggleFareDetails}
            expandedLink={isExpanded}
          />
        </UitkLink>
      )}
    </>
  );
};
